document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-dbmv]').forEach(section => {
        if (typeof Swiper === 'undefined') return;

        /* Initialise every slider in the section (desktop + mobile) */
        section.querySelectorAll('.dbmv-swiper').forEach(swiperEl => {
            const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
            if (!slideCount) return;

            const multiple = slideCount > 1;
            const pagEl = swiperEl.querySelector('.swiper-pagination');

            new Swiper(swiperEl, {
                pagination: (pagEl && multiple)
                    ? { el: pagEl, clickable: true }
                    : false,
                slidesPerView: 1,
                loop: multiple,
                speed: 700,
                autoplay: multiple
                    ? { delay: 3000, disableOnInteraction: false }
                    : false,
                allowTouchMove: multiple,
                preloadImages: false,
                lazy: { loadPrevNext: true },
                /* recalculate when the slider becomes visible at a breakpoint */
                observer: true,
                observeParents: true
            });
        });

        /* Play / Pause video only when visible */
        const videos = section.querySelectorAll('video');

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    const video = entry.target;
                    if (entry.isIntersecting) {
                        video.play().catch(() => { });
                    } else {
                        video.pause();
                    }
                });
            }, { threshold: 0.4 });

            videos.forEach(video => observer.observe(video));
        } else {
            videos.forEach(video => video.play().catch(() => { }));
        }
    });

});
